import SettingsContent from '../Wrapper';
import Index from './Index';
import { frontendURL } from '../../../../helper/URLHelper';
import {requireAuth} from "../../dashboard.routes";
import {FEATURE_FLAGS} from "../../../../featureFlags";

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_MGMT.HEADER',
        icon: 'tag',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          roles: ['administrator'],
          meta: {
            permissions: ['administrator'],
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_list',
          roles: ['administrator'],
          component: Index,
          beforeEnter: requireAuth,
          meta: {
            permission: FEATURE_FLAGS.LABELS,
            permissions: ['administrator'],
          }
        },
      ],
    },
  ],
};
